export default {
  /* Super Panel */
  socialNetworks: 'redes sociais',
  sentEmails: 'enviou e-mails',
  peoplePerDay: 'Pessoas por dia',
  peoplePerMonth: 'Pessoas por mês',
  statsPerApp: 'estatísticas de aplicações',
  search: 'Busca',
  name: 'Nome',
  people: 'Pessoas',
  person: 'Pessoa',
  sentMessages: 'enviou mensagens',
  messagesParts: 'partes mensagens',
  applicationsPerPage: 'Aplicativos por página',
  cellphoneRecords: 'registros de celular',
  totalRecords: 'Total de registros',
  noName: 'Nameless',
  noJourneyId: 'Without ID',
  noAppsToShow: 'Não há aplicativos para mostrar',
  manualPayment: 'Pagamento manual',
  manualCollection: 'Coleta manual',
  noDataYet: 'Não há dados no momento'
}
